export const SET_CUSTOMER = 'SET_CUSTOMER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS';
export const SET_ACTIVE_BILLING_ACCOUNT = 'SET_ACTIVE_BILLING_ACCOUNT';
export const SET_PAYMENT_OPTIONS = 'SET_PAYMENT_OPTIONS';
export const REMOVE_PAYMENT_OPTION = 'REMOVE_PAYMENT_OPTION';
export const SET_BALANCE = 'SET_BALANCE';
export const SET_VOICE = 'SET_VOICE';
export const SET_BUSINESS_UNIT = 'SET_BUSINESS_UNIT';
